import React, { useState, useContext } from "react";

import Sidebar from "./Sidebar";
import MobileMenuButton from "./MobileMenuButton";
import TabNavigation from "./common/TabNavigation";
import { BrandGateContext } from "./brands/RequireBrand";

const DashboardLayout = ({ children, title, subtitle, currentUser, navConfig, primaryAction, secondaryActions = [] }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const brandGate = useContext(BrandGateContext);
  const showContent = brandGate === "ready";

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  return (
    <>
      {/* Mobile backdrop overlay - must be outside flex container */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-20 lg:hidden"
          onClick={closeSidebar}
        />
      )}
      
      <div className="flex h-screen min-w-0 max-w-full overflow-x-hidden bg-theme-secondary">
        {/* Sidebar */}
        <div className="overflow-visible">
          <Sidebar isOpen={sidebarOpen} onClose={closeSidebar} currentUser={currentUser} />
        </div>

        {/* Main content area - entire section with border radius that curves into sidebar */}
        <div className="flex-1 flex flex-col min-h-0 min-w-0 rounded-tl-2xl rounded-bl-2xl bg-theme-main -ml-px relative overflow-hidden">
          {/* Top bar with mobile menu button and title */}
          <div className={`flex items-start justify-between bg-theme-main ${navConfig && navConfig.length > 0 ? '' : 'border-b border-theme-shadow'}`}>
            <div className="flex items-start flex-1 min-w-0">
              <div className="flex items-center h-16 lg:hidden pl-4 sm:pl-6">
                <MobileMenuButton onClick={toggleSidebar} />
              </div>
              {(title || subtitle) && (
                <div className="pl-4 sm:pl-6 lg:pl-8 pr-4 sm:pr-6 lg:pr-8 py-4 flex-1 min-w-0 flex flex-col justify-center">
                  {title && (
                    <h1 className="text-xl font-semibold text-theme-text">
                      {title}
                    </h1>
                  )}
                  {subtitle && (
                    <div className="text-sm text-theme-secondary-text mt-1 flex items-center gap-2">
                      {typeof subtitle === 'string' ? subtitle : subtitle}
                    </div>
                  )}
                </div>
              )}
            </div>
            <div className="flex items-center gap-3 px-4 sm:px-6 lg:px-8 h-16">
              {secondaryActions.map((action, index) => (
                <React.Fragment key={index}>{action}</React.Fragment>
              ))}
              {primaryAction && primaryAction}
            </div>
          </div>

          {/* Tab Navigation */}
          {navConfig && navConfig.length > 0 && (
            <div className="flex-shrink-0 z-10 px-4 sm:px-6 lg:px-8 border-b border-theme-shadow bg-theme-main overflow-visible">
              <TabNavigation items={navConfig} />
            </div>
          )}

          {/* Main content */}
          <main className="flex-1 min-h-0 min-w-0 max-w-full overflow-y-auto overflow-x-hidden bg-theme-main text-theme-text">
            <div
              id="dashboard-main-content"
              className="py-6 px-4 sm:px-6 lg:px-8 w-full min-w-0 max-w-full box-border"
            >
              {showContent ? children : null}
            </div>
          </main>
        </div>
      </div>
    </>
  );
};

export default DashboardLayout;
